module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 3rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "value": _vm.row.saiqu.name,
      "title": "场次"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.exame,
      "title": "考试"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.row.baoming.ldname,
      "title": "联系人"
    }
  }), _vm._v(" "), (_vm.canSubmit) ? _c('van-cell', {
    attrs: {
      "title": "视频",
      "value": _vm.formData.video.length + '/1'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    attrs: {
      "minSize": 0,
      "fileList": _vm.formData.video,
      "limit": 1,
      "fileName": _vm.row.saiqu.name + '-' + _vm.row.baoming.ldname,
      "name": 'video'
    },
    on: {
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传一段视频")]) : _vm._e()], 1), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6fdf46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormExameUploadVideo.vue
// module id = 2253
// module chunks = 0